import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { assetManagementRouter} from './asset-management.router';
import { RouterModule } from '@angular/router';
import { AssetManagementDashboardComponent} from "./auth-tools/asset-management-dashboard/asset-management-dashboard.component";
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReportsComponent } from './reports/reports.component';
import { NgChartsModule } from 'ng2-charts';
import { MatDialogModule } from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import { AssetsViewComponent } from './assets-view/assets-view.component';
import { SystemAssetsVerificationViewComponent } from './assets-view/system-assets-verification-view/system-assets-verification-view.component';
import { DataAssetCaptureModule } from '../shared-workflows/data-asset-capture/data-asset-capture.module';
import { SystemAssetCaptureModule } from '../shared-workflows/system-asset-capture/system-asset-capture.module';
import { DataAssetManualUpdateComponent } from './assets-view/data-asset-manual-update/data-asset-manual-update.component';
import { SystemAssetManualUpdateComponent } from './assets-view/system-asset-manual-update/system-asset-manual-update.component';


@NgModule({
  declarations: [
    AssetManagementDashboardComponent,
    ReportsComponent,
    AssetsViewComponent,
    SystemAssetsVerificationViewComponent,
    DataAssetManualUpdateComponent,
    SystemAssetManualUpdateComponent,
    
  ],
  imports: [
    assetManagementRouter,
    RouterModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    NgbModule,
    MatProgressSpinnerModule,
    NgChartsModule,
    MatDialogModule,
    MatIconModule
    
]
})
export class AssetManagementModule { }
